// Add your JS customizations here

document.addEventListener("DOMContentLoaded", function() {
    // On form elements, keep label on top when value is present
    var formElements = document.querySelectorAll('.login-username, .login-password');
    for (var i = 0; i < formElements.length; i++) {
        formElements[i].querySelector('input').addEventListener('focusout', function() {
            if (this.value.length > 0) {
                this.parentElement.classList.add('has-value');
            } else {
                this.parentElement.classList.remove('has-value');
            }
        });
    }
});

const logoInput = document.getElementById('input_logo');
if (logoInput) {
	const logoConfirmation = document.getElementById('logo-confirmation');
	const logoRemoval = document.getElementById('logo-removal');
	const logoRemove = document.getElementById('remove_logo');
	const filePreview = document.getElementById('file-preview');
	const inputFileRemove = document.getElementById('logo_remove');

	logoInput.addEventListener('change', function() {
		if (logoInput.value) {
			logoConfirmation.style.display = 'block';
			logoRemoval.style.display = 'none';
		} else {
			logoConfirmation.style.display = 'none';
		}
	});

	logoRemove.addEventListener('click', function() {
		logoInput.value = '';
		logoRemoval.style.display = 'block';
		logoConfirmation.style.display = 'none';
		filePreview.style.display = 'none';
		inputFileRemove.value = '1';
	});
}
